import React, { useState } from 'react';

import './hint-modal.css';

export const HintModal = (props) => {
  const [show, setShow] = useState(false);
  return <>
    <div className="hint" onClick={() => setShow(true)}>Get a hint</div>
    {show && <div className='modal-overlay' onClick={() => setShow(false)}>
      <div className="hint-modal" onClick={(e) => e.stopPropagation()}>
        {props.children}
        <div className="close-icon" onClick={() => setShow(false)}>&times;</div>
      </div>
    </div>}
  </>
}
